#import "~/graphql/fragments/PaginatorInfo.graphql"

query personalVideosCount(
    $limit: Int = 20
    $page: Int = 1
    $inMyInterests: Boolean = true
    $excludeVideoIds: [ID!]
) {
    videos(
        first: $limit
        page: $page
        withinYourSpecialisation: $inMyInterests
        exclude: $excludeVideoIds
    ) {
        paginatorInfo {
            ...PaginatorInfo
        }
    }
}
